export const colors = {
  darkPrimary: "#558f37"
};
